<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 24 24"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" :fill="fill" r="12"/>
    <g clip-path="url(#clip0_878_296337)">
      <path clip-rule="evenodd" d="M12.6269 6.07706L17.5738 6.22153C17.7767 6.22749 17.9282 6.37904 17.9346 6.58207L18.0787 11.5313C18.0788 11.5342 18.0784 11.5372 18.078 11.5401C18.0777 11.5428 18.0773 11.5454 18.0773 11.548C18.077 11.5672 18.0753 11.5862 18.0725 11.6056C18.0719 11.6093 18.0713 11.613 18.0708 11.6167C18.0698 11.6243 18.0687 11.6317 18.067 11.6391C18.0626 11.6586 18.0563 11.6777 18.0492 11.6967C18.0479 11.7003 18.0468 11.7039 18.0456 11.7075C18.0436 11.7137 18.0416 11.7199 18.039 11.7258C18.0295 11.7475 18.0172 11.7686 18.0043 11.7893C18.0027 11.7918 18.0013 11.7944 18 11.797C17.9982 11.8003 17.9964 11.8036 17.9943 11.8068C17.9767 11.8325 17.9567 11.8571 17.9337 11.88L11.7851 18.0286C11.608 18.2057 11.3381 18.2229 11.1823 18.067L6.08981 12.9746C5.93394 12.8187 5.95116 12.5488 6.12828 12.3717L12.2782 6.22179C12.2808 6.21916 12.2837 6.21693 12.2866 6.21469C12.2889 6.21285 12.2913 6.211 12.2935 6.20891C12.3052 6.19815 12.3174 6.18807 12.33 6.17846C12.3414 6.16973 12.3528 6.16129 12.3648 6.15362C12.3769 6.14585 12.3894 6.13905 12.4022 6.13222C12.4152 6.12539 12.4284 6.11885 12.4418 6.11329C12.4547 6.10796 12.4678 6.10373 12.481 6.09948C12.495 6.09508 12.509 6.09109 12.5232 6.08798C12.5363 6.08524 12.5494 6.0832 12.5628 6.08165C12.5781 6.07978 12.593 6.07863 12.608 6.07847C12.6107 6.07838 12.6134 6.07807 12.6161 6.07776C12.6197 6.07736 12.6232 6.07695 12.6269 6.07706ZM15.6673 9.90382C15.2773 10.2937 14.6428 10.2935 14.2527 9.90335C13.863 9.51369 13.8631 8.87952 14.253 8.4896C14.643 8.09969 15.2772 8.09948 15.6669 8.48914C16.057 8.87926 16.0572 9.5139 15.6673 9.90382Z" :fill="iconFill" fill-rule="evenodd"/>
    </g>
    <defs>
      <clipPath id="clip0_878_296337">
        <rect :fill="iconFill" height="14" transform="translate(5 5)" width="14"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'Sold',
  props: {
    width: {
      type: String,
      required: false,
      default: '16'
    },
    height: {
      type: String,
      required: false,
      default: '16'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#218838'
    },
    iconFill: {
      type: String,
      required: false,
      default: '#FFF'
    },
  },
};
</script>
